import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanYesNo',
})
export class BooleanYesNoPipe implements PipeTransform {
  transform(value: any): any {
    return value ? 'Yes' : 'No';
  }
}
